/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownLeftIcon20Light = forwardRef('ArrowDCornerDownLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14 13a3 3 0 0 0 3-3V1.5a.5.5 0 1 0-1 0V10a2 2 0 0 1-2 2H3.207l4.647-4.646a.5.5 0 1 0-.708-.708l-4.651 4.652a1.7 1.7 0 0 0 0 2.404l4.651 4.652a.5.5 0 0 0 .708-.708L3.207 13H14Z" })));
});
